import React, { useEffect } from "react";
import LandscapeProgramLayout from "../LandscapeProgramLayout";
import { useAuthContext } from "../../../context/auth";
import BottomNav from "../BottomNav";
import { ReservationsDetailData } from "../../../Api";
import api from "../../../lib/api";

const DIFFICULTY_OPTIONS: {
  value: "easy" | "normal" | "hard";
  label: string;
  gradient: string;
}[] = [
  {
    value: "easy",
    label: "Easy",
    gradient: "linear-gradient(135deg, #E3FAFF 0%, #53CAF5 100%)",
  },
  {
    value: "normal",
    label: "Normal",
    gradient: "linear-gradient(135deg, #FFF5E0 0%, #F6B731 100%)",
  },
  {
    value: "hard",
    label: "Hard",
    gradient: "linear-gradient(159deg, #FFEBEB 0%, #FF5757 100%)",
  },
];

function HiluxDifficultyCheck() {
  const [reservations, setReservations] =
    React.useState<ReservationsDetailData>([]);

  const {
    did,
    classId,
    selectedUserIdsByRow,
    hiluxDifficulties,
    setHiluxSessionId,
    sendSetHiluxSession,
  } = useAuthContext();

  const STATIONS = Array.from({ length: 8 }, (_, i) => i);

  useEffect(() => {
    if (classId) {
      api.fits.reservationsDetail(classId).then((res) => {
        setReservations(res.data);
      });
    }

    if (did === "0") {
      const teams = STATIONS.filter(
        (stIdx) =>
          hiluxDifficulties[stIdx] !== null &&
          hiluxDifficulties[stIdx] !== undefined,
      ).map((stIdx) => ({
        teamNumber: stIdx + 1,
        difficulty: hiluxDifficulties[stIdx]!.toUpperCase() as
          | "EASY"
          | "NORMAL"
          | "HARD",
        userIds: selectedUserIdsByRow[stIdx] || [],
      }));

      if (teams.length > 0) {
        const username = localStorage.getItem("username") || "";
        const storeName = localStorage.getItem("name") || "";
        api.fits
          .hiroxSetupCreate({ username, storeName, classId, teams })
          .then((res) => {
            setHiluxSessionId(res.data.sessionId);
            sendSetHiluxSession(res.data.sessionId);
          });
      }
    }
  }, [classId, did, hiluxDifficulties, selectedUserIdsByRow]);

  return (
    <LandscapeProgramLayout step={5}>
      <div className="h-full w-full flex relative">
        <div className="p-[60px] flex flex-col gap-[40px] items-center w-full">
          <div className="flex items-center justify-center w-full">
            <h1 className="gradient-text text-[70px] font-bold">TEAM 안내</h1>
          </div>
          <div className="grid grid-cols-4 gap-x-[30px] gap-y-[24px] w-full">
            {STATIONS.map((stIdx) => {
              const diff = hiluxDifficulties[stIdx] ?? null;
              return (
                <div
                  key={stIdx}
                  className="flex flex-col gap-[16px] items-center"
                >
                  <h2
                    className="text-[36px] font-extrabold text-white uppercase text-center"
                    style={{ textShadow: "0px 0px 30px rgba(0,0,0,0.25)" }}
                  >
                    TEAM {stIdx + 1}
                  </h2>
                  <div className="relative p-[20px] pb-[72px] gap-x-[30px] gap-y-[20px] flex flex-wrap bg-white/[0.12] min-h-[260px] max-h-[260px] w-full rounded-[12px] overflow-y-auto scrollbar-hide items-start content-start">
                    {selectedUserIdsByRow[stIdx]?.map((userId, idx) => {
                      const reservation = reservations.find(
                        (r) => r.user?.id === userId,
                      );
                      return (
                        <div className="flex items-center gap-[12px]" key={idx}>
                          <img
                            src={
                              reservation?.user?.profileImageUrl ||
                              "/defaultProfileImage.png"
                            }
                            alt="profile"
                            className="w-[44px] h-[44px] rounded-full"
                          />
                          <span className="text-[24px] text-white text-center">
                            {reservation?.user?.name}
                          </span>
                        </div>
                      );
                    })}
                    <div className="absolute bottom-[20px] left-1/2 -translate-x-1/2 flex gap-[8px] items-center">
                      {DIFFICULTY_OPTIONS.filter(
                        (option) => option.value === diff,
                      ).map((option) => (
                        <div
                          key={option.value}
                          className="w-[120px] py-[12px] px-[20px] rounded-[8px] text-[20px] font-extrabold text-[#020A1F] text-center capitalize"
                          style={{ background: option.gradient }}
                        >
                          {option.label}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <BottomNav />
    </LandscapeProgramLayout>
  );
}

export default HiluxDifficultyCheck;
